import React from 'react';
import PropTypes from 'prop-types';
import '../styles/hcHomepageStyles.css';

export const FilterButton = (props) => {
    const handleFilterClick = () => {
        return () => props.handleClick(props.buttonId, props.filterButtonType);
    };
    
    return (
        <button 
            style={props.style}
            onClick={handleFilterClick(props)}
        >
            {props.filterButtonName}
        </button>
    );
};

FilterButton.propTypes = {
    handleClick: PropTypes.func.isRequired,
    filterButtonType: PropTypes.string.isRequired,
    filterButtonName: PropTypes.string.isRequired,
    style: PropTypes.object.isRequired,
    // The buttonId is the array index for FilterPane's isOn list
    buttonId: PropTypes.number.isRequired,
};

export default FilterButton;



// WEBPACK FOOTER //
// ./src/components/FilterButton.jsx